import { useContext, useEffect, useRef } from 'react';
import { ServicesContext } from 'app/items/shared/context_interface';
import './map.scss';
import classNames from 'classnames';
import { useFlyToFarm } from 'app/agriculture/hooks/useFlyTo/useFlyToFarm';
import { useSelectedFarm } from 'app/agriculture/hooks/useSelectedFarm/useSelectedFarm';

interface AgricultureMapProps {
    className?: string;
}

export function AgricultureMap({ className }: AgricultureMapProps) {
    const { cesiumMap, mapService } = useContext(ServicesContext);
    const mainMap = useRef<HTMLDivElement>(null);
    const farm = useSelectedFarm();
    const { flyToFarm } = useFlyToFarm();

    useEffect(() => {
        mapService.initialise();
        flyToFarm(farm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!mainMap.current) return;
        cesiumMap.appendMap(mainMap.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mainMap.current]);

    return (
        <div
            id="AgricultureMap"
            data-testid="AgricultureMap"
            className={classNames('AgricultureMap', className)}
        >
            <div id="map-tooltip" />
            <div id="main-map" ref={mainMap} />
        </div>
    );
}
